import { defineMessages } from "react-intl";

const messages = defineMessages({
  addNewPersonButton: {
    id: "associations.people.addNewPersonButton",
    defaultMessage: "+ Add New Person",
    description: "Add new person button on Person association modal",
  },
  alreadyAssociated: {
    id: "associations.people.alreadyAssociated",
    defaultMessage:
      "This person is already associated with this record. To remove the association, click the “Remove” icon from the edit panel.",
    description: "A tooltip over the checkbox when person is already assigned to a target record",
  },
  associationLimitError: {
    id: "associations.people.associationLimitError",
    defaultMessage:
      "You can only relate up to {limit} {limit, plural, one {person} other {people}} to an individual activity",
    description: "Body of limit reached error on People association modal",
  },
  associationLimitErrorTitle: {
    id: "associations.people.associationLimitError.title",
    defaultMessage: "Limit of related people reached",
    description: "Title of limit reached error on People association modal",
  },
  cantAssociateWithSelf: {
    id: "associations.people.cantAssociateWithSelf",
    defaultMessage: "Assigning person to itself is not allowed",
    description: "A tooltip over the checkbox when person is already a target company",
  },
  deselectCount: {
    id: "associations.people.title.deselect.count",
    defaultMessage: "{count, plural, one {# person} other {# people}} deselected",
    description: "Title of People Association modal with deselected count",
  },
  footerOkButton: {
    id: "associations.people.footer.okButton",
    defaultMessage:
      "{addPeople, select, true {Add} other {Update}} {multiselect, select, true {People} other {Person}}",
    description: "Add button title on People Associations modal",
  },
  header: {
    id: "associations.people.header",
    defaultMessage: "Select {multiselect, select, true {People} other {Person}}",
    description: "Header of People Associations modal",
  },
  notEditableRowTooltip: {
    id: "associations.people.notEditable.rowTooltip",
    defaultMessage: "You don't have permission to edit this person",
    description: "Tooltip on a disabled person row the user isn't allowed to link",
  },
  okButton: {
    id: "associations.people.addNewPersonModal.okButton",
    defaultMessage: "Create and Add Person",
    description: "Create button title on Create Person modal when called from Select People modal",
  },
  placeholder: {
    id: "associations.people.search.placeholder",
    defaultMessage: "Search for a person",
    description: "Search bar placeholder for person association modal",
  },
  selectedCount: {
    id: "associations.people.title.selected.count",
    defaultMessage: "{count, plural, one {# new person} other {# new people}} selected",
    description: "Title of People Association modal with selected count",
  },
});

export default messages;
